var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:youtube-icon",
    clipPath: "url(#clip0_12429_36590)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.4693 2.63152C23.3316 2.12289 23.0632 1.65919 22.6906 1.28659C22.318 0.913989 21.8543 0.645494 21.3457 0.507838C19.4836 0 11.9894 0 11.9894 0C11.9894 0 4.4948 0.015372 2.63272 0.52321C2.12409 0.660874 1.66039 0.929383 1.28781 1.302C0.915225 1.67462 0.646757 2.13834 0.509138 2.64698C-0.0540957 5.95552 -0.272584 10.997 0.524604 14.1732C0.662237 14.6818 0.930712 15.1455 1.30329 15.5181C1.67588 15.8907 2.13957 16.1592 2.64819 16.2968C4.51026 16.8047 12.0047 16.8047 12.0047 16.8047C12.0047 16.8047 19.499 16.8047 21.361 16.2968C21.8696 16.1592 22.3333 15.8907 22.7059 15.5181C23.0785 15.1455 23.347 14.6818 23.4847 14.1732C24.0787 10.8599 24.2618 5.82158 23.4693 2.63152Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.60156 12.0067L15.8186 8.40567L9.60156 4.80469V12.0067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12429_36590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.8717,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.554c726b9e1548db560517d79043872a.svg";
export { ForwardRef as ReactComponent };